import { Injector } from '@angular/core'
import { ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';

import { AuthenticationService } from '../../../authorization/authentication.service';

import { SubscribeBase } from '../../bases/subscribe.base';
import { chekcPermissionFunc } from '../../base-functions/permission.base-functions';

export class PermissionsDrirectivesBase extends SubscribeBase {
    private serviceAuthentication: AuthenticationService;

    private minUserType: String;

    constructor(private injector: Injector,
        private element: ElementRef,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        minUserType: string) {

        super();

        this.serviceAuthentication = this.injector.get(AuthenticationService);

        this.minUserType = minUserType;
        this.addSubscribe('KEY-1', this.serviceAuthentication.currentUser, () => this.check(), () => this.check());
    }

    ngOnInit() { }

    ngAfterViewInit() {
        setTimeout(() => {
            this.check();
        }, 555)
    }

    ngOnDestroy() {
        this.allitemsUnsubscribeAndRemove();
    }

    check() {
        const currentUser = this.serviceAuthentication.currentUserValue;
        const minUserType = this.minUserType;

        if (!this.templateRef || !this.viewContainer)
            return;

        const res = chekcPermissionFunc(currentUser, minUserType.toString());
        if (res)
            this.createEmbed();
        else
            this.clearTemp();
    }

    private clearTemp() {
        this.viewContainer.clear();
    }
    private createEmbed() {
        this.clearTemp();
        this.viewContainer.createEmbeddedView(this.templateRef);
    }
}